import { Controller } from "@hotwired/stimulus"

// Shows the maximum that belongs to the selected policy. The others are hidden
// and disabled, so a stale value in a hidden field is never submitted.
export default class extends Controller {
  static targets = ["select", "maximum"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const policy = this.selectTarget.value

    this.maximumTargets.forEach((maximum) => {
      const active = maximum.dataset.policy === policy
      maximum.hidden = !active
      maximum.querySelectorAll("input").forEach((input) => { input.disabled = !active })
    })
  }
}
